export default "__VITE_ASSET__BalP5GO5__"